import {css} from 'aphrodite';
import React from 'react';

import getTestProps from 'test/lib/cypress/getTestProps';
import {LabelStyle, Size} from 'ui-library/inputs/InputConstants';
import TextField from 'ui-library/inputs/TextField';

import {automationFileConfigStyles, SectionNumber} from './AutomationFileConfigUtils';
import {AutomationInputFileConfigSpec, ClientAutomationOutputFileConfigSpec} from './RunSchemaSpecConstants';

// exported for test only
export const AutomationFileConfigEditorHeaderTestAttrs = {
  name: {component: 'AutomationFileConfigEditorHeader', element: 'configName'},
  error: {component: 'AutomationFileConfigEditorHeader', element: 'configNameError'},
};

interface AutomationFileConfigEditorHeaderProps<
  T extends AutomationInputFileConfigSpec | ClientAutomationOutputFileConfigSpec,
> {
  automationFileConfig: T;
  description: string;
  onUpdateConfig: (newConfig: T) => void;
  isDuplicateName?: boolean;
}

export default function AutomationFileConfigEditorHeader<
  T extends AutomationInputFileConfigSpec | ClientAutomationOutputFileConfigSpec,
>(props: AutomationFileConfigEditorHeaderProps<T>): JSX.Element {
  return (
    <div className={css(automationFileConfigStyles.subsection, automationFileConfigStyles.subsectionBorder)}>
      <SectionNumber sectionNumber={1} />
      <div className={css(automationFileConfigStyles.innerTitle)}>Configure the display name</div>
      <div
        className={css(automationFileConfigStyles.description, automationFileConfigStyles.sectionDescription)}
      >
        {props.description}
      </div>
      <div className={css(automationFileConfigStyles.nameTextBox)}>
        <TextField
          autoFocus={props.automationFileConfig.name === ''}
          label="Display name"
          labelStyle={LabelStyle.HIDDEN}
          value={props.automationFileConfig.name}
          size={Size.MEDIUM}
          onChange={(e) => {
            props.onUpdateConfig({
              ...props.automationFileConfig,
              name: e.target.value,
            });
          }}
          placeholder="Display name"
          hasError={props.isDuplicateName}
          dataTestAttrs={AutomationFileConfigEditorHeaderTestAttrs.name}
        />
        {props.isDuplicateName && (
          <div
            className={css(automationFileConfigStyles.error)}
            {...getTestProps(AutomationFileConfigEditorHeaderTestAttrs.error)}
          >
            This display name is duplicated.
          </div>
        )}
      </div>
    </div>
  );
}
